export const host = "http://localhost:5006/api/v1";
